<template>
  <div>
    <figure class="highcharts-figure">
      <highcharts ref="chart" :options="options" />
      <p class="highcharts-description highcharts-linked-description">
        <strong>Figure : </strong> {{ $t('compGraphicsDevicesPie.help') }}
      </p>
    </figure>
    <br v-if="!onlyGraphics" />
    <b-table
      v-if="!onlyGraphics"
      :striped="true"
      :narrowed="true"
      :hoverable="true"
      :data="series"
    >
      <b-table-column
        :label="$t('compGraphicsDevicesPie.label-1')"
        v-slot="props"
      >
        {{ props.row.name }}
      </b-table-column>
      <b-table-column
        :label="$t('emissions.t.co2e.short')"
        numeric
        v-slot="props"
      >
        {{ Math.round(props.row.y) | splitNumberTons }} &plusmn;
        {{ Math.round(props.row.uncertainty) | splitNumberTons }}
      </b-table-column>
      <b-table-column
        :label="$t('compGraphicsDevicesPie.label-2')"
        numeric
        v-slot="props"
      >
        {{
          Math.round(
            (props.row.y / ghgi.emissions.devices.intensity.intensity) * 100
          )
        }}
        %
      </b-table-column>
    </b-table>
  </div>
</template>

<script>
import '@/plugins/highcharts.js'

export default {
  name: 'DevicesPie',
  props: {
    ghgi: {
      type: Object,
      default: null
    },
    onlyGraphics: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    series: function () {
      let series = []
      for (let device of this.ghgi.devices) {
        let oindex = series.findIndex(
          (obj) => obj.name === this.$t(device.type)
        )
        if (oindex < 0) {
          series.push({
            name: this.$t(device.type),
            y: device.intensity.intensity,
            uncertainty: device.intensity.uncertainty
          })
        } else {
          series[oindex].y += device.intensity.intensity
          series[oindex].uncertainty += device.intensity.uncertainty
        }
      }
      return series
    },
    options: function () {
      const self = this
      return {
        chart: {
          type: 'pie'
        },
        title: {
          verticalAlign: 'middle',
          floating: true,
          text: `<b>${self.$options.filters.splitNumberTons(
            Math.round(self.ghgi.emissions.devices.intensity.intensity)
          )} ${self.$t('t.co2e')} </b>`
        },
        plotOptions: {
          pie: {
            innerSize: '60%',
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              formatter () {
                return `<b>${
                  this.point.name
                }:</b> ${self.$options.filters.splitNumberTons(
                  this.y
                )} ${self.$t('t.co2e')}`
              }
            },
            showInLegend: true
          }
        },
        series: [
          {
            name: this.$t('carbon.footprint'),
            colorByPoint: true,
            data: this.series
          }
        ],
        legend: {
          enabled: false
        },
        tooltip: {
          formatter: function () {
            return `${this.key}<br/><b>${self.$options.filters.splitNumberTons(
              this.y
            )} ${self.$t('t.co2e')}</b>`
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.highcharts-figure {
  min-width: 320px;
  max-width: 700px;
  margin: 1em auto;
}
.highcharts-description {
  text-align: center;
  color: '#777777';
  font-style: italic;
}
</style>
